import { GET_MEDICAL_HISTORY_SUCCESS } from "../actions/patientAction"


const getMedicalHistoryReducer = (state = [], { type,  data = [] }) => {
    switch (type) {
      case GET_MEDICAL_HISTORY_SUCCESS:
        return data
      default:
        return state
    }
  }
  
  export default getMedicalHistoryReducer